import { render } from "./GRBG_net.vue?vue&type=template&id=65726fca&scoped=true"
import script from "./GRBG_net.vue?vue&type=script&lang=js"
export * from "./GRBG_net.vue?vue&type=script&lang=js"

import "./GRBG_net.vue?vue&type=style&index=0&id=65726fca&scoped=scoped&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65726fca"]])

export default __exports__